import { useAppDispatch, useAppSelector } from "./hooks";

import {
  pauseSubscriptionAsync,
  getSubscriptionDetailsAsync,
  selectSubscriptionStatus,
  unPauseSubscriptionAsync,
} from "../features/subscriptions/subscriptionSlice";

const usePauseSubscription = () => {
  const dispatch = useAppDispatch();

  const apiStatus = useAppSelector(selectSubscriptionStatus);

  const pauseSubscription = () => {
    if (apiStatus === "loading") return;
    dispatch(pauseSubscriptionAsync()).then(action => {
      if (pauseSubscriptionAsync.fulfilled.match(action)) {
        dispatch(getSubscriptionDetailsAsync());
      }
    });
  };

  return pauseSubscription;
};

const useUnpauseSubscription = () => {
  const dispatch = useAppDispatch();
  const apiStatus = useAppSelector(selectSubscriptionStatus);

  const unpauseSubscription = async () => {
    if (apiStatus === "loading") return;
    const action = await dispatch(unPauseSubscriptionAsync());
    if (unPauseSubscriptionAsync.fulfilled.match(action)) {
      await dispatch(getSubscriptionDetailsAsync());
    }
    return action;
  };

  return unpauseSubscription;
};

export { usePauseSubscription, useUnpauseSubscription };
